<div class="modal-header bg-dark text-white">
    <h5 class="modal-title">
        <i class="fas fa-info-circle fa-fw"></i>
        Webscan-Fleet 서비스 이용약관 (End User License Agreement)
    </h5>
    <button type="button" class="close text-white" (click)="clickCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <h1>Webscan-Fleet 서비스 이용약관</h1>

    <ul class="list-unstyled list-clause">
        <li>
            <h3>제1장 총 칙</h3>
            <ul class="list-unstyled">
                <li>
                    <h5>
                        제 1 조 (목적)
                    </h5>
                    <p>
                        본 약관은 회원(Webscan-Fleet 서비스 약관에 동의한 자를 말합니다. 이하 “회원” 이라고 합니다.)이 주식회사 크레스트인볼브먼트 (이하 “회사” 라고 합니다.)이 제공하는 Webscan-Fleet 서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리 및 의무, 기타 제반 사항을 규정함을 목적으로 합니다. 본 약관에 명시되지 않은 사항에 대하여는 위치정보의 보호 및 이용 등에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관계 법령 및 회사가 정한 세부이용지침 등의 규정에 따릅니다.
                    </p>
                </li>
                <li>
                    <h5>
                        제 2 조 (용어의 정의)
                    </h5>
                    <p>
                        본 약관에서 사용하는 용어의 정의는 다음 각 호와 같으며, 본 이용약관에 규정되지 않은 용어는 서비스 관련 안내자료와 사업자료 등에서 서비스제공자가 일반적으로 사용하는 의미로 해석됩니다.
                    </p>
                    <ol>
                        <li>
                            “위치정보서비스”(이하 “서비스”)란 서비스제공자가 개인위치정보주체의 위치정보를 수집하여 위치기반서비스사업자인 이용자에게 제공하는 서비스를 말하며, 그 구체적인 내용은 본 약관 제5조에 기술되어있습니다.
                        </li>
                        <li>
                            “단말기”란 위치정보를 수집하기 위해 이용하는 것으로 이동전화 또는 GPS 및 통신기능이 탑재된 전용단말기를 말합니다.
                        </li>
                        <li>
                            “위치정보시스템”은 위치정보사업과 위치기반서비스사업을 위하여 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제2조 제1항 제1호의 규정에 따라 정보통신망을 통하여 위치정보를 수집•분석•저장•이용•제공할 수 있도록 서로 유기적으로 연계된 컴퓨터의 하드웨어, 소프트웨어, 데이터베이스 및 인적 자원의 결합체를 말합니다.
                        </li>
                        <li>
                            “개인위치정보주체”란 개인위치정보로 식별되는 자를 말합니다.
                        </li>
                        <li>
                            “솔루션 요금“이라 함은 회사의 위치정보시스템을 이용하는 대가로 고객이 매월 통신사 부가서비스 형태로 납부하는 금액을 의미합니다.
                        </li>
                        <li>
                            “서비스 요금“이라 함은 이동통신사에서 취하는 통신기본료와 회사에서 취하는 솔루션 요금을 통합한, 소비자가 지불하는 총 금액을 의미합니다.
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 3 조 (이용약관의 효력 및 변경)
                    </h5>
                    <ol>
                        <li>
                            본 약관은 서비스를 신청한 고객과 개인위치정보주체가 본 약관에 동의하고 회사가 정한 소정의 절차에 따라 서비스의 이용자로 등록함으로써 효력이 발생합니다.
                        </li>
                        <li>
                            회사는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의 규제에 관한 법률 등 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
                        </li>
                        <li>
                            회사가 약관을 개정할 경우에는 기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를 명시하여 현행약관과 함께 그 적용일자 10일 전부터 적용일 이후 상당한 기간 동안 공지만을 하고, 개정 내용이 회원에게 불리한 경우에는 그 적용일자 30일 전부터 적용일 이후 상당한 기간 동안 각각 이를 서비스 홈페이지에 게시하거나 회원에게 전자적 형태(전자우편, SMS 등)로 약관 개정 사실을 발송하여 고지합니다.
                        </li>
                        <li>
                            회사가 전항에 따라 회원에게 통지 또는 공지 고지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 이용약관에 승인한 것으로 봅니다. 회원이 개정약관에 동의하지 않을 경우 회원은 이용계약을 해지할 수 있습니다.
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 4 조 (관계법령의 적용)
                    </h5>
                    <p>
                        본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.
                    </p>
                </li>
                <li>
                    <h5>
                        제 5 조 (서비스의 내용)
                    </h5>
                    <ol>
                        <li>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered align-items-center mb-0">
                                    <thead>
                                    <tr>
                                        <th>서비스 명</th>
                                        <th>서비스 내용</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Webscan-Fleet</td>
                                        <td>
                                            <ul>
                                                <li>차량 위치 관제</li>
                                                <li>차량정보, 안전운전관리 시스템 제공</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li>
                            본 서비스는 개인 휴대폰 웹서비스 등을 통하여 차량의 위치정보 조회, 안전운전관리 등의 생활편의 서비스를 제공하며 인명이나 재산보호를 목적으로 하지 않습니다. 따라서 회사는 인명이나 재산의 보호에 대한 법적 책임을 지지 않습니다.
                        </li>
                        <li>
                            본 서비스는 위치정보의 보호 및 이용 등에 관한 법률에 따른 위치정보사업 및 위치기반서비스 사업입니다. 회사는 법률에서 정한 절차를 거쳐 위치정보허가 취득 및 위치기반서비스 신고를 마쳤으며 해당 사업을 영위합니다.
                        </li>
                        <li>
                            GPS 단말기로 취득된 위치정보는 이동통신단말을 통하여 위치정보허가사업자의 서버 시스템에 전송하고, 위치정보 및 기타 서비스를 위한 정보를 분석, 조합하여 Webscan-Fleet 또는 당사와 계약이 된 위치기반서비스 사업자에게 위치정보를 제공합니다.
                        </li>
                        <li>
                            차량의 경우 GPS 좌표가 무선통신망을 통해 위치정보시스템으로 수집되고, 고객이 위치정보시스템에 설정한 차량 및 운전자 정보와 연동되어 개인위치정보가 수집/이용/제공됩니다.
                        </li>
                        <li>
                            회사는 고객의 차량 위치조회 요청 시 휴대폰 등록번호 ID와 P.W등이 일치하면 합당한 고객으로 간주하고 위치정보시스템을 이용할 수 있도록 허가합니다.
                        </li>
                        <li>
                            위치정보의 보호 및 이용 등에 관한 법률에서 정하는 긴급구조기관 등 국가 기관의 적법한 요청 시 고객의 동의 없이 회사는 차량위치정보를 수집 및 제공할 수 있으며 수집 및 제공 목적, 내용, 일시 등을 고객에게 휴대폰 SMS 등의 방법으로 즉시 통보합니다. 다만, 즉시 통보가 개인위치정보주체의 생명·신체에 대한 뚜렷한 위험을 초래할 우려가 있는 경우에는 그 사유가 소멸한 후 지체 없이 통보합니다.
                        </li>
                        <li>
                            차량단말기가 부착된 고객의 차량을 타인이 운전하게 되는 경우 고객이 직접 운전자에게 위치정보를 수집할 수 있는 장치가 부착된 사실을 고지하고 위치정보수집 및 이용 동의서를 받은 후 위치정보를 수집 및 이용해야 합니다. 운전자가 위치정보 수집 및 이용 동의서에 서명함으로써 위치정보이용자가 위치정보를 수집하는데 동의하는 것으로 간주합니다. 이런 일련의 과정을 생략 혹은 허위로 하여 발생할 수 있는 모든 민•형사상의 책임은 위치정보를 이용하는 고객에게 있습니다.
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 6 조 (서비스 이용요금)
                    </h5>
                    <ol>
                        <li>
                            회사가 제공하는 솔루션은 차량의 운행사에 한하여 서비스에 명시된 요금을 지불하며, 스마트폰 Application 위치관제 서비스를 이용하는 사용자는 별도 요금 없이 무료지만 용도에 따라 요금이 부과될 수도 있습니다.
                        </li>
                        <li>
                            이동통신망을 이용한 대가로 지불하는 이동통신 요금과, 회사의 위치정보시스템을 이용한 대가로 지불하는 솔루션 요금이 통합 청구되며, 당월 요금이 익월 중순에 청구서가 발행되고 익월 말까지 납부해야 합니다. 
                        </li>
                        <li>
                            차량 단말기 가격 및 서비스 요금은 고객이 서비스 가입시, 작성 및 서명한 가입신청서를 따릅니다.
                        </li>
                        <li>
                            회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.
                        </li>
                        <li>
                            무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.
                        </li>
                        <li>
                            이동통신사 약정기간에 따른 차량 단말기 보조금을 위하여, 본 서비스 계약기간은 기본 2~3년으로 합니다. 단, 가입시 작성한 서비스 이용신청서나 별도 계약서에 따른 위약금을 납부하고 언제든지 중도해지가 가능합니다.
                        </li>
                        <li>
                            <h4>(통신사 요금제)</h4>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered align-items-center mb-0">
                                    <thead>
                                        <tr>
                                            <th>KT 요금제</th>
                                            <th>월정액(원)</th>
                                            <th>LGU+ 요금제</th>
                                            <th>월정액(원)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>KT GIGA IoT 38</td>
                                            <td>3,850원</td>
                                            <td>IoT LTE 30</td>
                                            <td>3,850원</td>
                                        </tr>
                                        <tr>
                                            <td>KT GIGA IoT 55</td>
                                            <td>5,500원</td>
                                            <td>IoT LTE 40</td>
                                            <td>4,000원</td>
                                        </tr>
                                        <tr>
                                            <td>KT GIGA IoT 77</td>
                                            <td>7,700원</td>
                                            <td>IoT LTE 50</td>
                                            <td>5,000원</td>
                                        </tr>
                                        <tr>
                                            <td>KT GIGA IoT 110</td>
                                            <td>11,000원</td>
                                            <td>IoT LTE 65</td>
                                            <td>6,500원</td>
                                        </tr>
                                        <tr>
                                            <td>KT GIGA IoT 165</td>
                                            <td>16,500원</td>
                                            <td>IoT LTE 75</td>
                                            <td>7,500원</td>
                                        </tr>
                                        <tr>
                                            <td>KT GIGA IoT 220</td>
                                            <td>22,000원</td>
                                            <td>IoT LTE 100</td>
                                            <td>10,000원</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li>
                            <h4>(부가서비스요금)</h4>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered align-items-center mb-0">
                                    <thead>
                                    <tr>
                                        <th>KT 부가서비스</th>
                                        <th>월정액(원)</th>
                                        <th>LG 부가서비스</th>
                                        <th>월정액(원)</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>차량 관제 30</td>
                                        <td>3,000원</td>
                                        <td>차량관리서비스 20</td>
                                        <td>2,000원</td>
                                    </tr>
                                    <tr>
                                        <td>차량 관제 50</td>
                                        <td>5,000원</td>
                                        <td>차량관리서비스 30</td>
                                        <td>3,000원</td>
                                    </tr>
                                    <tr>
                                        <td>차량 관제 70</td>
                                        <td>7,000원</td>
                                        <td>차량관리서비스 40</td>
                                        <td>4,000원</td>
                                    </tr>
                                    <tr>
                                        <td>차량 관제 100</td>
                                        <td>10,000원</td>
                                        <td>차량관리서비스 50</td>
                                        <td>5,000원</td>
                                    </tr>
                                    <tr>
                                        <td>차량 관제 200</td>
                                        <td>20,000원</td>
                                        <td>차량관리서비스 10</td>
                                        <td>10,000원</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 7 조 (서비스 이용의 제한 및 정지)
                    </h5>
                    <ol>
                        <li>
                            <span>회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의 서비스 이용을 제한하거나 중지시킬 수 있습니다.</span>
                            <ul>
                                <li>회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우</li>
                                <li>서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우</li>
                                <li>전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우</li>
                                <li>국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 경우</li>
                                <li>기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우</li>
                            </ul>
                        </li>
                        <li>회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 회원에게 알려야 합니다.</li>
                        <li>고객의 해지 및 정지 의사가 있을 경우, 회사가 그 업무를 대행하여 가입 이동통신사 등과 연계하여 진행합니다.</li>
                        <li>고객은 고객의 사유로 서비스의 일시 정지를 신청할 수 있으며, 정지기간은 1회 최대 180일로 하며, 연 2회까지 가능합니다. 단, 가입 이동통신사의 정책에 따라 변경될 수 있습니다.</li> 
                        <li>이동통신망이나 솔루션 요금 납부 일시정지 기간은 약정 기간에 포함되지 않습니다.</li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 8 조 (개인위치정보의 이용 또는 제공)
                    </h5>
                    <ol>
                        <li>회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.</li> 
                        <li>회사는 서비스 제공을 위하여 고객의 위치정보를 이용할 수 있으며, 고객은 본 약관에 동의함으로 이에 동의한 것으로 간주됩니다.</li>
                        <li>회사는 서비스 제공을 위해 회사와 제휴한 이동통신 사업자의 무선통신망과 GPS시스템 등을 이용하여 대한민국 내에서 차량의 위치정보 및 차량운행 분석 데이터를 제공합니다. 차량 위치정보 서비스를 제공 받는 자는 운전자, 법인 시스템 관리자이며, 차량 긴급 상황 발생 통지 등의 위치기반 생활편의 서비스 목적으로 사용됩니다.</li>
                        <li>차량단말기가 부착된 고객의 경우 차량을 타인이 운전하게 되는 경우 고객이 직접 운전자에게 위치정보를 수집할 수 있는 장치가 부착된 사실을 고지하고 위치정보수집및이용 동의서를 받은 후 위치정보를 수집 및 이용해야 합니다. 운전자가 위치정보수집 및 이용 동의서에 서명함으로써 위치정보이용자가 위치정보를 수집하는데 동의하는 것으로 간주합니다.</li>
                        <li>회사는 고객이 제공한 개인위치정보를 당해 고객의 동의 없이 서비스 제공 이외의 목적으로 이용하지 아니합니다.</li>
                        <li>회사는 고객이 제공한 개인위치정보를 당해 고객의 동의 없이 제3자에게 제공하지 아니합니다.</li>
                        <li>회사는 고객의 개인위치정보를 고객이 지정하는 제3자에게 제공할 경우 매회 고객에게 제공받는 자, 제공 일시 및 제공목적을 즉시 통보합니다.</li>
                        <li>
                            <span>다만, 회사는 다음 각호에 해당하는 경우에 한하여 고객이 지정한 이동전화 단말기 또는 전자우편주소로 통보할 수 있습니다.</span>
                            <ul>
                                <li>개인위치정보를 수집한 당해 통신단말장치가 문자,음성 또는 영상의 수신기능을 갖추지 아니한 경우</li>
                                <li>개인 위치정보 주체가 개인위치정보를 수집한 당해 통신단말장치 외의 통신단말장치 또는 전자우편 주소 등으로 통보할 것을 미리 요청한 경우</li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 9 조 (개인위치정보 수집．이용．제공사실 확인의 보유기간)
                    </h5>
                    <ol>
                        <li>
                            회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 고객에 대한 위치정보 수집．이용．제공 사실 확인 자료를 위치정보시스템에 자동으로 기록하며, 고객불만 응대를 위하여 기록시점으로부터 6개월간 보존합니다.
                        </li>
                        <li>
                            회사는 위치 정보의 보호 및 이용 등에 관한 법률 제24조 제4항의 규정에 의하여 고객이 동의의 전부 또는 일부를 철회한 경우에는 지체 없이 수집된 개인위치정보 및 위치정보 이용제공사실 확인자료(동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 이용제공사실 확인 자료에 한합니다)를 파기합니다. 다만, 국세기본법, 법인세법, 부가가치세법 기타 관계법령의 규정에 의하여 보존할 필요성이 없는 경우에는 관계법령에 따라 보존합니다.
                        </li>
                        <li>
                            회사는 위치정보시스템에 자동으로 기록되는 내용에는 위치정보주체를 직접적으로 식별할 수 있는 정보를 최소화 합니다.
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 10 조 (개인위치정보주체의 권리)
                    </h5>
                    <ol>
                        <li>회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치정보서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다. 이 경우 회사는 수집한 개인위치정보 및 위치정보 이용, 제공사실 확인 자료를 파기합니다.</li>
                        <li>회원은 회사에 대하여 언제든지 개인위치정보의 수집, 이용 또는 제공의 일시적인 중지를 요구할 수 있으며, 회사는 이를 거절할 수 없고 이를 위한 기술적 수단을 갖추고 있습니다.</li>
                        <li>
                            <span>회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.</span>
                            <ul>
                                <li>본인에 대한 위치정보 수집, 이용, 제공사실 확인자료</li>
                                <li>본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용</li>
                            </ul>
                        </li>
                        <li>회원은 제1호 내지 제3호의 권리행사를 위해 회사의 소정의 절차를 통해 요구할 수 있습니다.</li>
                        <li>회사는 14세 미만의 회원에 대해서는 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의를 당해 회원과 당해 회원의 법정대리인으로부터 동의를 받아야 합니다. 이 경우 법정대리인은 제11조에 의한 회원의 권리를 모두 가집니다.</li>
                        <li>
                            <span>
                                회사는 14세 미만의 아동의 개인위치정보 또는 위치정보 이용, 제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공하고자 하는 경우에는 14세 미만의 아동과 그 법정대리인의 동의를 받아야 합니다. 단, 아래의 경우는 제외합니다.
                            </span>
                            <ul>
                                <li>위치정보 및 위치기반서비스 제공에 따른 요금정산을 위하여 위치정보 이용, 제공사실 확인자료가 필요한 경우</li>
                                <li>통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우</li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 11 조 (8세 이하의 아동 등의 보호의무자의 권리)
                    </h5>
                    <ol>
                        <li>
                            <span>회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.</span>
                            <ul>
                                <li>8세 이하의 아동</li>
                                <li>금치산자</li>
                                <li>장애인복지법제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진및직업재활법 제2조제2호의 규정에 의한 중증장애 인에 해당하는 자(장애인복지법 제29조의 규정에 의하여 장애인등록을 한 자에 한한다)</li>
                            </ul>
                        </li>
                        <li>8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에 보호 의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다. </li>
                        <li>보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다. </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 12 조 (위치정보관리책임자의 지정)
                    </h5>
                    <ol>
                        <li>회사는 위치정보를 적절히 관리, 보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영합니다.</li>
                        <li>위치정보관리책임자는 위치정보서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.</li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 13 조 (회사의 의무)
                    </h5>
                    <ol>
                        <li>회사는 서비스와 관련한 고객의 불만사항이 접수되는 경우 이를 신속하게 처리하여야 하며, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 고객에게 통지합니다.</li>
                        <li>회사는 위치정보의 보호 및 이용 등에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 통신비밀보호법, 전기통신사업법 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.</li>
                        <li>회사는 고객서비스를 보다 활성화하여 최적화된 서비스를 제공하고, 신상품이나 이벤트 정보안내, 설문조사 등 고객 지향적인 마케팅을 수행하기 위해 이용계약 체결 시 수집한 고객의 개인정보 및 서비스 이용과 관련한 정보를 활용할 수 있습니다. 단, 고객의 동의 범위를 초과하여 이용하거나 제3자에게 제공하고자 하는 경우에는 미리 당해 고객에게 동의를 받아야 합니다. 이 경우 고객은 회사의 동의 요청을 거절할 수 있습니다. </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 14 조 (고객의 권리)
                    </h5>
                    <ol>
                        <li>고객은 유무선인터넷 등을 통해 회사의 고객 개인위치정보의 이용 및 제공에 대한 동의의 전부 또는 일부에 대하여 철회할 수 있습니다.</li>
                        <li>고객은 유무선인터넷 등을 통해 회사의 고객 개인위치정보의 이용 및 제공의 일시적인 중지를 요구할 수 있습니다.</li>
                        <li>
                            <span>고객은 회사에 대하여 다음 각호의 1의 자료 등의 열람 또는 고지를 요구할 수 있습니다. </span>
                            <ul>
                                <li>고객에 대한 위치정보 수집,이용,제공사실 확인자료</li>
                                <li>고객의 개인위치정보가 위치 정보의 보호 및 이용 등에 관한 법률 또는 다른 법률의 규정에 의하여 제3자에게 제공된 이유 및 내용 </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 15 조 (고객의 의무)
                    </h5>
                    <ol>
                        <li>고객은 서비스이용계약에 따라 요금을 지정된 기일까지 납입하여야 하며, 회사에 알린 요금청구 주소 및 연락처가 변경된 경우에는 이를 회사에 알려야 합니다.</li>
                        <li>고객은 서비스 이용을 위해 필요한 제반 정보를 제공, 등록할 경우 현재의 사실과 일치하는 완전한 정보를 제공, 등록하여야 하며, 변경사항이 발생할 경우 즉시 갱신하여야 합니다.</li>
                        <li>고객은 휴대폰이 정상 동작을 유지하도록 관리하여야 하며, 휴대폰의 정상동작이 유지되지 않아 서비스 제공에 지장이 있을 때에는 해당 휴대폰의 보수, 교환 등의 처리를 신속히 행하여 원활한 서비스가 이루어지도록 합니다.</li>
                        <li>
                            <span>고객은 서비스 이용 시 다음 각 호의 1에 해당하는 행위를 하여서는 아니 됩니다. </span>
                            <ul>
                                <li>가입신청 또는 변경 시 허위 사실을 기재하는 행위</li>
                                <li>타인의 명예를 손상시키거나 불이익을 주는 행위</li>
                                <li>공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위</li>
                                <li>서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염 자료를 등록 또는 유포하는 행위</li>
                                <li>타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위</li>
                                <li>자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위</li>
                                <li>서비스의 이용과 관련하여 취득한 타인의 개인위치정보를 무단으로 유용 또는 유출하는 행위</li>
                                <li>기타 불법적이거나 부당한 행위 </li>
                            </ul>
                        </li>
                        <li>고객은 관계 법령, 이 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다. </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 16 조 (계약자와 실사용자가 다른 경우)
                    </h5>
                    <ol>
                        <li>서비스 이용계약을 체결한 명의자와 위치정보수집단말 장치의 실사용자가 다른 경우에는 위치정보를 수집할 수 있는 물건을 사용하는 실사용자를 명시하여야 하며, 실사용자의 동의를 얻어야 합니다.</li>
                        <li>서비스 이용계약에 명시한 계약자, 실사용자 외 실사용자가 누구인지 알 수 없는 경우에는 계약체결자인 명의자를 개인위치정보주체로 간주합니다.</li>
                        <li>법인이나 단체와 계약을 체결하는 경우, 회사는 당해 법인이나 단체에게 실제 사용자인 개인위치정보 주체를 특정하여 지정할 것을 요청할 수 있으며, 당해 법인이나 단체는 개인에게 이 사실을 고지하여, 개인의 허락을 득해야 합니다.</li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 17 조 (손해배상)
                    </h5>
                    <ol>
                        <li>회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의 규정을 위반한 행위로 회원에게 손해가 발생한 경우 회원은 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.</li>
                        <li>회원이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 회원에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회원은 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.</li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 18 조 (면책)
                    </h5>
                    <ol>
                        <li>
                            <span>회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 회원에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.</span>
                            <ul>
                                <li>천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우</li>
                                <li>서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의 고의적인 서비스 방해가 있는 경우</li>
                                <li>회원의 귀책사유로 서비스 이용에 장애가 있는 경우</li>
                                <li>고객 휴대폰 또는 차량 단말기가 전파가 도달하지 않은 등 서비스가 불가능한 지역에 있을 때</li>
                                <li>이동통신 네트워크의 이상, 위치정보시스템의 장애 발생 및 위치정보사업자가 전기통신 서비스를 정상적으로 제공 못하거나 기타 사유로 위치정보가 전달되지 않을 때</li>
                                <li>제1호 내지 제5호를 제외한 기타 회사의 고의 및 과실이 없는 사유로 인한 경우</li>
                            </ul>
                        </li>
                        <li>회사는 고객이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖에 서비스를 통하여 얻은 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다.</li>
                        <li>회사의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우 회사는 인터넷 홈페이지 등에 이를 공지하거나 E-mail 등의 방법으로 고객에게 통지합니다. 단, 회사가 통제할 수 없는 사유로 인하여 사전 공지가 불가능한 경우에는 사후에 공지합니다.</li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 19 조 (규정의 준용)
                    </h5>
                    <ol>
                        <li>본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.</li>
                        <li>본 약관에 규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의합니다.</li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 20 조 (분쟁의 조정 및 기타)
                    </h5>
                    <ol>
                        <li>회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보의 보호 및 이용 등에 관한 법률 제28조의 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.</li>
                        <li>회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보보호법 제43조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다. </li>
                    </ol>
                </li>
                <li>
                    <h5>
                        제 21 조 (회사의 연락처)
                    </h5>
                    <p>
                        회사의 상호 및 주소 등은 다음과 같습니다.
                    </p>
                    <ol>
                        <li>상 호 : 주식회사 크레스트인볼브먼트</li>
                        <li>대 표 자 : 박 성 준</li>
                        <li>주 소 : 서울특별시 성동구 성수이로 118 (성수동2가) 성수아카데미타워 205호(성수)</li>
                        <li>대표전화 : 1833-5697</li>
                    </ol>
                </li>
                <li>
                    <h5>
                        부칙
                    </h5>
                    <ol>
                        <li>제1조 (시행일) 이 약관은 2017년 11월 15일 부터 시행한다. </li>
                        <li>
                            <span>제2조 위치정보관리책임자는 2017년 11월을 기준으로 다음과 같이 지정합니다.</span>
                            <ul>
                                <li>소 속 : 주식회사 크레스트인볼브먼트</li>
                                <li>연락처 : 1833-5697</li>
                                <li>팩스 : 02-578-0669</li>
                                <li>회사 웹사이트 : https://allgps.co.kr/</li>
                                <li>서비스 웹사이트 : fleet.crestinvolvement.com</li>
                                <li>위치정보관리책임자 : 상무 진상국</li>
                            </ul>
                        </li>
                    </ol>
                </li>
            </ul>
        </li>
    </ul>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        ngbAutofocus
        (click)="clickCancel()">
        <i class="far fa-times-circle fa-fw"></i>
        닫기
    </button>
</div>